<template>

    <div class="wrap">

        <div class="fixed-bg position-fixed" style="z-index: -99;" v-if="!ismobile && showrender" >
<!--            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/HwyXo6T7jC4?autoplay=1&showinfo=0&controls=0&mute=1&loop=1&rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
            <iframe width="100%" height="100%" :src="mission_youtube_video_url(current)" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <div class="fixed-bg position-fixed" :style="bg_style" style="z-index: -100"></div>
        <div class="fixed-overlay position-fixed"></div>
        <div class="position-fixed  typing-fixed v-fade d-flex" style="z-index: 1;" v-show="!showrender">
            <typewrighter @finish="typing_done = true" :text="loading_text"  :speed="typing_speed" class="text-lg-center" style="max-width:90%;" font_color="#FFF"></typewrighter>
        </div>
        <b-container style="max-width: 990px;" v-if="next_launch">
            <b-row>
                <b-col cols="12">
                    <div class="spacex-timeline">
                        <h1 class="text-center my-5" id="main-head" :class="{active:typing_done}">SpaceX Launches</h1>
                        <div v-if="showrender">
                            <a :href="'#' + flightID(next_launch)" @click.prevent="ScrolltoMission(next_launch)" class="d-none">
                                <div class="next-launch position-fixed">
                                    <div v-if="next_launch.links.mission_patch_small" class="mb-3 text-center">
                                        <img :src="next_launch.links.mission_patch_small" class="img-fluid" style="max-width: 150px">
                                    </div>
                                    <h3>NEXT LAUNCH
                                        <br><span class="mission-name">{{next_launch.mission_name}}</span>
                                        <br>
                                        @ {{next_launch.launch_site.site_name}}
                                    </h3>
                                    <timer :time="next_launch.launch_date_unix">
                                        <template v-slot:default="slotProps">
                                            {{slotProps.time.d}} Days {{slotProps.time.h}} Hours {{slotProps.time.m}} Minutes {{slotProps.time.s}} Seconds
                                        </template>
                                    </timer>
                                </div>
                            </a>


                            <div v-for="launch,key in launches">
                                <!--            <h2>{{launch.launch_year}} -{{launch.mission_name}}</h2>-->
                                <!--            <img :src="launch.links.mission_patch_small">-->
                                <vue-timeline-update
                                        :id = "flightID(launch)"
                                        :date="new Date(launch.launch_date_utc)"
                                        :title="mission_title(launch)"

                                        :thumbnail="launch.links.mission_patch_small"
                                        :category="mission_category(launch)"
                                        icon="done"
                                        :color="mission_color(launch)"
                                        theme="dark"
                                />
                                <div v-if="launch.mission_name == next_launch.mission_name">

                                    <h4 id="clock">Launch CountDown <br>
                                        <timer :time="next_launch.launch_date_unix">
                                            <template v-slot:default="slotProps">
                                                {{slotProps.time.d}} Days {{slotProps.time.h}} Hours {{slotProps.time.m}} Minutes {{slotProps.time.s}} Seconds
                                            </template>
                                        </timer>
                                    </h4>
                                </div>

                                <b-row class="mt-3">
                                    <b-col cols md="4">
                                        <h5>Launch Site</h5>
                                        {{launch.launch_site.site_name}}
                                    </b-col>
                                </b-row>

                                <b-row class="mt-3">
                                    <b-col cols md="4">
                                        <h5>Rocket Type</h5>
                                        {{launch.rocket.rocket_type}}
                                    </b-col>
                                    <b-col cols md="4">
                                        <h5>Rocket Name</h5>
                                        {{launch.rocket.rocket_name}}
                                    </b-col>
                                    <b-col cols md="4">
                                        <h5>Rocket Payload</h5>
                                        {{displaypayload(launch.rocket.second_stage.payloads)}}
                                    </b-col>
                                </b-row>

                                <p v-if="launch.details" class="mt-3">{{launch.details}}</p>

                                <div class="details slide-down my-3" v-if="launch.display == true">
                                    <div class="mt-3 yt-container" v-if="launch.links.youtube_id != null">
                                        <iframe width="560" height="315" :src="'https://www.youtube.com/embed/' + launch.links.youtube_id" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                    </div>

                                    <b-card-group columns v-if="launch.links.flickr_images.length > 0" class="mt-3">

                                        <b-card

                                                v-for = "url,_index in launch.links.flickr_images"
                                                :img-src="url"
                                                :img-alt="launch.mission_name"
                                                @click="showModal(url,launch.mission_name)"
                                                overlay
                                                style="cursor:pointer"
                                        >
                                        </b-card>
                                    </b-card-group>
                                </div>

                                <div v-if="launch" class="mt-3">
                                    <b-button size="sm" pill variant="danger" v-if="launch.display != true && launch.links.flickr_images.length > 0 && launch.links.youtube_id" @click="$set(launch,'display', true);current = launch">More Info</b-button>
<!--                                    <b-button size="sm" v-if="launch.display == true" @click="launch.display = false">See Less</b-button>-->
                                </div>
                                <!--            <iframe width="560" height="315" src="https://www.youtube.com/embed/AQFhX5TvP0M" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
                            </div>
                        </div>



<!--                        <pre v-if="this.showrender">-->
<!--                            {{launches}}-->
<!--                        </pre>-->


                    </div>
                </b-col>
            </b-row>
        </b-container>
        <b-modal ref="my-modal" size="lg" hide-footer :title="'Mission: ' + curretTitle">
           <img :src="currentImg" class="img-fluid">
        </b-modal>
    </div>



</template>

<script>

    import axios from "axios";
    import typewrighter from "../components/typewrighter";
    import timer from "../components/timer";

    export default {
        name: "index",
        components:{typewrighter,timer},
        data:function(){
            return {
                loading_text:"Activate launch pad sound suppression system...|Activate main engine hydrogen burnoff system...|Main engine start...",
                typing_done:false,
                api_url : "https://api.spacexdata.com/v3/launches/",
                launchesData:[],
                current: null,
                next_launch:null,
                loading:true,
                showrender:false,
                typing_speed : 30,
                currentImg:null,
                curretTitle:null,
            }
        },
        mounted() {
            this.ReadData();
        },
        computed:{
          recent_youtube(){

              let launchesData = this.launchesData;
              let launch = launchesData.find( launch => launch.links.youtube_id != null );
              return launch.links.youtube_id;
          },
            recent_seccess_lanuch(){
              let launches = this.launches;
              let launch = launches.find( launch => launch.launch_success == true );
              return launch;
          },
          ismobile(){
              return this.mobileCheck();
          },
          launches(){
              let launchesData = this.launchesData;
              launchesData.sort(function(a, b) {
                  return  b.launch_date_unix - a.launch_date_unix;
              });

              return launchesData;
          },
          bg_style(){
              let launch =  this.current;
              if(launch !== null && launch.links.flickr_images.length > 0){

                let bg_image = launch.links.flickr_images[Math.floor(Math.random() * launch.links.flickr_images.length)];

                return {
                    "background-image" : `url(${bg_image})`
                }

              }else{
                  return {
                      "background-image" : `url(https://live.staticflickr.com/65535/49956109706_cffa847208_o.jpg)`
                  }
                // return null;
              }
          }
        },
        methods:{
            loaded(){

                let self = this;
                console.log("typing done",this.typing_done);

              if(this.typing_done == false){
                  setTimeout(function(){
                      self.loaded()
                  },300);
                  return;
              }

              // if(this.loading_text == false){
              //     this.loading_text =  this.loading_text;
              // }else{
              //
              //
              // }
                this.typing_done = true;
                this.typing_speed = 30;
                this.loading_text = "4....|3....|2....|1....|launch...";
                self.showrender = true;
                setTimeout(function(){
                    console.log("success",self.recent_seccess_lanuch);
                    self.ScrolltoMission(self.recent_seccess_lanuch);
                },1500);

            },
            mobileCheck(){
                let check = false;
                (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
                return check;
            },
            ReadData(){
                let self = this;
                let api_url = this.api_url;
                axios.get(api_url)
                .then(function (response) {
                    // handle success
                    self.launchesData = response.data;
                    if(!self.next_launch){
                        self.next_launch = self.launchesData[0]
                    }
                    console.log(response);
                    self.loaded();

                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .then(function () {
                    // always executed
                    self.loading = false;
                });


                api_url = this.api_url + "next";

                axios.get(api_url)
                    .then(function (response) {
                        // handle success
                        self.next_launch = response.data;

                    })
                    .catch(function (error) {
                        // self.next_launch = self.launchesData[0]
                        // handle error
                        console.log(error);

                    })
                    .then(function () {

                    });

            },
            mission_color(launch){

                // let _now = Math.round((new Date()).getTime() / 1000);
                // if(launch.launch_date_unix > _now){
                //     return "orange";
                // }

                if(launch.upcoming){
                    return "orange";
                }

                if( launch.launch_success == true ){
                    return "green";
                }else if(launch.launch_success == false){
                    return "red";
                }
            },
            mission_category(launch){


                if(launch.upcoming){
                    return "upcoming";
                }
                // let _now = Math.round((new Date()).getTime() / 1000);
                // if(launch.launch_date_unix > _now){
                //     return "Preparing";
                // }

                if( launch.launch_success == true ){
                    return "Success";
                }else if(launch.launch_success == false){
                    return "Fail";
                }
            },
            mission_date(launch){
                const unixTimestamp = launch.launch_date_unix;
                const milliseconds = unixTimestamp * 1000 // 1575909015000
                const dateObject = new Date(milliseconds)
                const humanDateFormat = dateObject.toLocaleString("en-US")
                return humanDateFormat;
            },
            details(launch){

                if( launch.details){

                    if(launch.showmore == true ){
                        return launch.details;
                    }else{
                        if(launch.links.youtube_id != null || launch.links.flickr_images.length > 0){
                            return launch.details + "<div><a class='see-more-link' href='javascript:void(0)'>see more >></a></div>";
                        }else{
                            return launch.details;
                        }

                    }

                }else{
                    return "";
                }

            },
            seemore(launch){

                launch.showmore = true;
                this.current = launch;

                // alert(launch.launch_date_unix);
                let details = launch.details;
                if(typeof launch.links.youtube_id != "undefined" && launch.links.youtube_id != null){
                    details += `
                        <div class="mt-3">
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/${launch.links.youtube_id}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>`
                }

                if( launch.links.flickr_images.length > 0){
                    details += `
                        <div class="grid">
                    `
                    launch.links.flickr_images.forEach(function (url,i) {
                        details += `<div class="grid-item"><img src="${url}" class="img-fluid mb-2" style="max-width: 400px"></div>`
                    })
                    details += `
                        </div>
                    `
                }
                launch.details = details;
            },
            mission_title(launch){
                return launch.mission_name + ' <br> ' + this.mission_date(launch);
            },
            mission_youtube_video_url(launch){
               
                if(launch == null){
                    // return "https://www.youtube.com/embed/"+this.recent_youtube+"?version=3&autoplay=1&showinfo=0&controls=0&mute=1&loop=1&rel=0";
                    let yid = this.random_pick_youtube_id();
                    console.log(yid);
                    return "https://www.youtube.com/embed/" + yid + "?version=3&autoplay=1&showinfo=0&controls=0&mute=1&loop=1&rel=0";
                }
                console.log(launch.links.youtube_id);
                return `https://www.youtube.com/embed/${launch.links.youtube_id}?version=3&autoplay=1&showinfo=0&controls=0&mute=1&loop=1&rel=0`;
            },
            random_pick_youtube_id(){
                let launchesData = this.launchesData;
                let launch = launchesData[Math.floor(Math.random() * launchesData.length)];
                if(launch.links.youtube_id != null){
                    return launch.links.youtube_id;
                }else{
                    this.random_pick_youtube_id();
                }

            },
            flightID(launch = null){
                // console.log(launch);
                if(launch == null){
                    return "";
                }
               return 'spx_' + launch.flight_number;
            },
            ScrolltoMission(launch){
                if(!launch){
                    return;
                }
                let filghtID = this.flightID(launch);
                console.log(filghtID);
                let element = document.querySelector(`#${filghtID}`);
                // element.scrollIntoView();
                console.log(filghtID,launch,element.offsetTop);
                document.documentElement.scrollTop = element.offsetTop - 150;

            },
            displaypayload(payloads){
                let p = [];
                payloads.forEach(function(payload,i){
                    let index = p.indexOf(payload.payload_type);
                    if(index == -1){
                        p.push(payload.payload_type);
                    }
                })
                return p.join(', ');
            },
            showModal(url,title) {
                this.currentImg = url;
                this.curretTitle = title;
                this.$refs['my-modal'].show()
            },
            hideModal() {
                this.$refs['my-modal'].hide()
            },
            toggleModal() {
                // We pass the ID of the button that we want to return focus to
                // when the modal has hidden
                this.$refs['my-modal'].toggle('#toggle-btn')
            }


        }
    }
</script>

<style scoped lang="scss">

</style>